import { apiSlice } from '../api/apiSlice';
import type {
  AttestPrerequisiteBody,
  AttestPrerequisiteResponse,
  CreatePdmpConfigPayload,
  PdmpConfig,
  PdmpConfigChangeHistoryEntry,
  UpdatePdmpConfigPayload
} from './pdmp.types';

const pdmpApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    attestPrerequisite: builder.mutation<AttestPrerequisiteResponse, AttestPrerequisiteBody>({
      query: (body) => ({
        body,
        method: 'POST',
        url: '/attest-prerequisite'
      })
    }),
    createPdmpConfig: builder.mutation<PdmpConfig, CreatePdmpConfigPayload>({
      invalidatesTags: ['PdmpConfig'],
      query: (body) => ({ body, method: 'POST', url: '/admin/pdmp-configs' }),
      transformResponse: (response: { data: PdmpConfig }) => response.data
    }),
    getPdmpConfigHistory: builder.query<PdmpConfigChangeHistoryEntry[], string>({
      query: (id) => `/admin/pdmp-configs/${id}/history`,
      transformResponse: (response: { data: PdmpConfigChangeHistoryEntry[] }) => response.data
    }),
    getPdmpConfigs: builder.query<PdmpConfig[], void>({
      providesTags: (result) =>
        result
          ? ['PdmpConfig', ...result.map(({ _id }) => ({ id: _id, type: 'PdmpConfig' as const }))]
          : ['PdmpConfig'],
      query: () => '/admin/pdmp-configs',
      transformResponse: (response: { data: PdmpConfig[] }) => response.data
    }),
    updatePdmpConfig: builder.mutation<PdmpConfig, UpdatePdmpConfigPayload>({
      invalidatesTags: ['PdmpConfig'],
      query: ({ id, ...body }) => ({ body, method: 'PATCH', url: `/admin/pdmp-configs/${id}` }),
      transformResponse: (response: { data: PdmpConfig }) => response.data
    })
  })
});

export const {
  useAttestPrerequisiteMutation,
  useCreatePdmpConfigMutation,
  useGetPdmpConfigHistoryQuery,
  useGetPdmpConfigsQuery,
  useUpdatePdmpConfigMutation
} = pdmpApi;

export { pdmpApi };
